import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Status } from 'src/app/enums/status';
import { saveAs } from 'file-saver';
import { CampaignOrderService } from 'src/app/services/campaign-order.service';
import { SharedService } from 'src/app/services/shared.service';
import { StihlCampaignOrderPubDTO } from 'src/app/models/stihl-campaign-dto';
import { visibleContentAnimation } from 'src/app/animations';

declare var $: any;

@Component({
  selector: 'app-edit-order-pub',
  templateUrl: './edit-order-pub.component.html',
  animations: [visibleContentAnimation]
})

export class EditOrderPubComponent implements OnInit, AfterViewChecked {

  model: StihlCampaignOrderPubDTO = new StihlCampaignOrderPubDTO();

  @Input() idOrder: string;
  @Input() origin: string;
  logoTipoUri: string;
  formDataValues: any[] = [];
  loadedData = 0;
  statusEnum = Status;
  showLogo = true;

  constructor(private route: ActivatedRoute,
    private campaignOrderService: CampaignOrderService,
    private toastr: ToastrService,
    private SharedService: SharedService,
    private changeRef: ChangeDetectorRef,
    private router: Router) {
  }

  ngAfterViewChecked(): void { this.changeRef.detectChanges(); }

  ngOnInit() {

    const that = this;

    if (this.idOrder !== null) {

      that.campaignOrderService.getOrderPubById(this.idOrder).subscribe(resp => {

        this.model = resp;

        if (this.model.Data.toLowerCase().indexOf(('"VALUE":"Sem logotipo"').toLowerCase()) > 0) {
          this.showLogo = false;
        }

        this.loadedData++;
        this.formDataValues = JSON.parse(this.model.Data);
        this.logoTipoUri = this.model.FileLogo.FileUri;
        this.loadedData++;
      }, (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao recuperar os dados',
          text: 'Ocorreu um erro'
        });
      });
    }
  }

  goBack() {
    if (this.origin == 'mi-area')
      this.router.navigate(["/myarea/orders-advertising/"]);
    else
      this.router.navigate(["/area-stihl/orders-advertising/"]);
  }


}
